/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

/**
 * Nl2Br filter.
 * Formats strings to replace new lines with html <br> element.
 * @author Jonny Cook <jcook@frontier.co.uk>
 * @param {string} value
 * @return {string}
 */
export default (value: string): string => {
    return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
};
